import React, { useEffect } from 'react';
import axios from 'axios';
import ValidationTypes from '../../util/validationTypes';
import LoadButton from './LoadButton';
import AlertBar from '../AlertBar';
import useLoadingForm from '../../hooks/loadingFormHook';
import Username from '../../static/dashboard/username.svg';
import Password from '../../static/dashboard/password.svg';
import LoadingSpinner from '../../static/dashboard/loadingspinner.svg';
import '../../styles/dashboard/ConnectDepop.css';

export default function ConnectDepop({ history }) {
    const connectFormRules = {
        username: [ValidationTypes.requiredString],
        password: [ValidationTypes.requiredString]
    };

    const submitConnectHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/500");
    };

    const successConnectHandler = () => {
        history.push('/dashboard');
    }

    const failConnectHandler = () => {
        // Code if failed to connect. Prob some auth error.
    }

    const { formData, handleChange, loading, loaded, handleSubmit, errorMapping } = useLoadingForm({
        username: '',
        password: ''
    }, submitConnectHandler, successConnectHandler, failConnectHandler, connectFormRules);
    

    // Preloading image on mount.
    // Honestly not sure if this is a hack because I've never done this before, but it seemed necessary
    // b/c spinner loading on connect is too slow and looks funky. 
    useEffect(() => {
        const img = new Image();
        img.src = LoadingSpinner;
    }, []);

    return (
        <>
        <AlertBar alertHTML="This is a secure connection <span role='img' aria-label='lock'>🔒</span> We don’t see or share your login information." />
        <div className="ConnectDepop">
            <div className="header">
                <h1>Connect Your Depop</h1>
                <p>Connect your Depop to start using Salewave</p>
            </div>
            <form 
            className="formDashboard"
            onSubmit={handleSubmit}>
                <div className={`username ${errorMapping.username ? 'form-error-input' : ''}`}>
                    <div><img src={Username} alt=""/></div>
                    <input 
                    className="withIcon"
                    type="text"
                    name="username"
                    value={formData.username}
                    placeholder="username"
                    onChange={handleChange} />
                </div>
                {errorMapping.username && <p className="form-error">{errorMapping.username}</p>}
                <div className={`password ${errorMapping.password ? 'form-error-input' : ''}`}>
                    <div><img src={Password} alt=""/></div>
                    <input 
                    className="withIcon"
                    type="password"
                    name="password"
                    value={formData.password}
                    placeholder="password"
                    onChange={handleChange} />
                </div>
                {errorMapping.password && <p className="form-error">{errorMapping.password}</p>}
                <LoadButton 
                loading={loading}
                loaded={loaded}
                defaultText="Connect"
                loadingText="Connecting"
                loadedText="Connected"
                theme="black" />
            </form>
            
        </div>
        </>
    )
}
